// extracted by css-extract-rspack-plugin
export default {"wrapper":"KYmcC_SPk5sILKAD","wrapperDisabled":"GP1DMfJGwkkpq9eb","trigger":"mm2W5Lr06nc__Jcc"};